/**
 * Ferme les popups Amelia au clic sur le fond.
 * Le dialogue Amelia a close-on-click-modal à false.
 */
export default function initAmeliaPopup() {
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    const overlay = target.closest('.am-forms-dialog');
    if (!overlay || target.closest('.el-dialog')) {
      return;
    }

    const close = overlay.querySelector('.el-dialog__headerbtn');
    if (close instanceof HTMLElement) {
      close.click();
    }
  });
}
